import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.606 13.423a1.305 1.305 0 1 1-1.845 1.845 1.305 1.305 0 0 1 1.845-1.845",
      stroke: "black",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "m11.381 8.963.88.293a.49.49 0 0 1 .339.469v.844c0 .479.383.87.862.88l.799.018a.49.49 0 0 1 .43.273l.415.83a.49.49 0 0 1-.092.57l-.597.596a.88.88 0 0 0-.014 1.232l.553.577a.49.49 0 0 1 .11.498l-.293.88a.49.49 0 0 1-.468.338h-.844a.88.88 0 0 0-.882.862l-.017.799a.49.49 0 0 1-.272.43l-.83.415a.495.495 0 0 1-.57-.092l-.596-.597a.88.88 0 0 0-1.233-.013l-.577.552a.49.49 0 0 1-.497.111l-.88-.294a.49.49 0 0 1-.338-.468v-.844a.88.88 0 0 0-.862-.881l-.798-.018a.49.49 0 0 1-.431-.272l-.415-.83a.495.495 0 0 1 .092-.57l.597-.596a.88.88 0 0 0 .014-1.233l-.552-.577a.49.49 0 0 1-.112-.497l.294-.88a.49.49 0 0 1 .469-.338h.843c.48 0 .871-.383.882-.862l.017-.799a.49.49 0 0 1 .273-.431l.83-.415a.495.495 0 0 1 .57.092l.596.597a.88.88 0 0 0 1.232.014l.577-.552a.49.49 0 0 1 .496-.111",
      stroke: "black",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "m18.342 9.992.764-.206a.41.41 0 0 0 .297-.328l.145-.892a.61.61 0 0 1 .503-.503l.89-.145a.41.41 0 0 0 .329-.296l.205-.765a.41.41 0 0 0-.136-.421l-.7-.572a.61.61 0 0 1-.184-.688l.321-.846a.41.41 0 0 0-.093-.433l-.56-.559a.41.41 0 0 0-.432-.093l-1.256.476-.849-1.039a.41.41 0 0 0-.421-.136l-.764.205a.41.41 0 0 0-.297.329l-.145.892a.61.61 0 0 1-.503.503l-.89.145a.41.41 0 0 0-.33.296l-.205.764a.41.41 0 0 0 .136.422l.699.571a.61.61 0 0 1 .183.687l-.322.847a.41.41 0 0 0 .093.433l.56.56c.113.113.283.15.433.093l.848-.322a.61.61 0 0 1 .686.185l.572.7a.41.41 0 0 0 .423.136",
      stroke: "black",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }